import { TActionsWithoutState } from '../../Interfaces/TActionsWithoutState';

import { getByUser } from './Actions/getByUser';
import { getMemberships } from './Actions/getMemberships';
import { updateByUser } from './Actions/updateByUser';

const actions = {
  getByUser,
  getMemberships,
  updateByUser
};

export type IAdminMembershipsActions = TActionsWithoutState<typeof actions>;

export default actions;
